module.exports = __webpack_public_path__ + "f077ba301cba25f4da6b9ef00c2afa1f.fbx";